import { useContext } from 'react';
import * as React from 'react';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { InputsDarkTheme } from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';

const MAX_FULL_PAGE_OFFERS = 3;

const LAYOUT_OPTIONS: DropdownInputOption[] = [
  { label: `Full Page`, value: `single` },
  { label: `Grid / List`, value: `grid` },
];

export function PostPurchaseLayout() {
  const {
    props: {
      settings: { layout },
    },
    setProps,
  } = useContext(PostPurchaseContext);

  const onChange = (val: DropdownInputOption) => {
    setProps((draft) => {
      draft.settings.layout = val.value as `single` | `grid`;

      if (val.value === `single`) {
        capOffersToMax(draft, MAX_FULL_PAGE_OFFERS);
      }
    });
  };

  return (
    <DropdownInput
      theme={InputsDarkTheme}
      options={LAYOUT_OPTIONS}
      defaultValue={getDefaultValue(layout)}
      onChange={onChange}
      optionStyles={{ textTransform: `uppercase` }}
    />
  );
}

function getDefaultValue(layout: string): DropdownInputOption {
  return layout === `grid` ? LAYOUT_OPTIONS[1] : LAYOUT_OPTIONS[0];
}

function capOffersToMax(draft: any, max: number) {
  if (draft.settings.offersCount <= max) return;

  draft.settings.offersCount = max;

  if (draft.offers?.length > max) {
    draft.offers = draft.offers.slice(0, max);
  }

  cleanupExcessOfferText(draft, max);
}

function cleanupExcessOfferText(draft: any, max: number) {
  if (!draft.content?.offersText) return;

  const offerKeys = Object.keys(draft.content.offersText);
  // eslint-disable-next-line no-restricted-syntax
  for (const key of offerKeys) {
    const index = parseInt(key.replace(`offer`, ``), 10);
    if (index > max) {
      delete draft.content.offersText[key];
    }
  }
}
